// import axios from 'axios';

import axiosInstance from "../../../../../Services/Global-Services/UnauthorizedTokenHandler";
const baseURL = process.env.REACT_APP_BASE_URL;
const API_URL = `${baseURL}/Policy/List`;

export const fetchPolicies = async () => {
  const payload = {
    OrgId: 104,
    CategoryId: 0,
    IsPublished: 0,
    GUID: '',
    pagenumber: 1,
    pagesize: 100
  };

  try {
    const res = await axiosInstance.post(API_URL, payload);
    const list = res.data?.Data?.policyList || [];
    console.log("✅ Policies fetched:", list.length);  // check this in browser console
    return list;
  } catch (error) {
    console.error(' Policy API error:', error);
    return [];
  }
};
